const STORAGE_PREFIX = 'impulse-user-interface-order';

const getStorageKey = (profileId) => `${STORAGE_PREFIX}:${profileId || 'guest'}`;

export const getUserInterfaceOrder = (profileId) => {
  try {
    const value = JSON.parse(localStorage.getItem(getStorageKey(profileId)) || '{}');
    return value && typeof value === 'object' ? value : {};
  } catch {
    return {};
  }
};

export const saveUserInterfaceOrder = (profileId, nextValue) => {
  const currentValue = getUserInterfaceOrder(profileId);
  localStorage.setItem(
    getStorageKey(profileId),
    JSON.stringify({ ...currentValue, ...nextValue }),
  );
};

export const sortBySavedOrder = (items = [], order = [], getKey = (item) => item?.id) => {
  if (!Array.isArray(order) || !order.length) return items;

  const positions = new Map(order.map((key, index) => [String(key), index]));

  return [...items].sort((first, second) => {
    const firstPosition = positions.get(String(getKey(first)));
    const secondPosition = positions.get(String(getKey(second)));

    if (firstPosition === undefined && secondPosition === undefined) return 0;
    if (firstPosition === undefined) return 1;
    if (secondPosition === undefined) return -1;
    return firstPosition - secondPosition;
  });
};

export const getMenuGroupKey = (group, index = 0) => (
  group?.folder?.id !== undefined
    ? `folder-${group.folder.id}`
    : `group-${group?.items?.map((item) => item.id).sort().join('-') || index}`
);
